<iframe [src]="iframe|safe: 'resourceUrl'" frameborder="0"></iframe>
